var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"sidebar-controls sidebar-controls--back"},[_c('router-link',{staticClass:"sidebar-controls__item",attrs:{"tag":"li","to":("/thread-id-" + (_vm.$route.params.id))}},[_vm._v("\n    К лентам\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }